<template>
    <div class="modal fade" id="costumModalresume" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES ADUAN</span>
                        <span v-else>COMPLAINT PROGRESS</span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <center>
                            <div class="row">
                                <div class="col-sm-12">
                                    <h1>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES ADUAN</span>
                                        <span v-else>COMPLAINT PROGRESS</span>
                                    </h1>
                                    <template v-for="(datalist, urutlist) in master" :key="urutlist">
                                        <ol class="olcards">
                                            <li :style="'--cardColor:' + datalist.colorditerima" style="background-color: #FAF0E6;padding: 30px;">
                                                <div class="content">
                                                    <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                                    <div class="title"><span :style="'color:' + datalist.colorditerima"
                                                            v-if="(bahasa === null) || (bahasa == 'ina')">Diterima</span>
                                                        <span v-else
                                                            :style="'color:' + datalist.colorditerima">Accepted</span>
                                                    </div>
                                                    <div class="text"
                                                        style="width: 100%;font-size: smaller !important;">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            Tanggal Aduan: {{ G_formatDate(datalist.createddate) }}<br>
                                                            Nama: {{ datalist.nama }}<br>
                                                            Alamat email: {{ datalist.alamat }}<br>
                                                            Kategori: {{ datalist.jenis }}<br>
                                                            Aduan: <span v-html="datalist.aduan"></span>
                                                        </span>
                                                        <span v-else>
                                                            Complaint Date: {{ G_formatDate(datalist.createddate) }}<br>
                                                            Name: {{ datalist.nama }}<br>
                                                            Email: {{ datalist.alamat }}<br>
                                                            Category: {{ datalist.jenis }}<br>
                                                            Complaint: <span v-html="datalist.aduan"></span><br>
                                                        </span>
                                                        <span :style="'color:' + datalist.colorditerima">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li :style="'--cardColor:' + datalist.colordiproses" style="background-color: #AFEEEE;padding: 30px;">
                                                <div class="content">
                                                    <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                                    <div class="title"><span :style="'color:' + datalist.colordiproses"
                                                            v-if="(bahasa === null) || (bahasa == 'ina')">Diproses</span>
                                                        <span v-else
                                                            :style="'color:' + datalist.colordiproses">Processed</span>
                                                    </div>
                                                    <div class="text"
                                                        style="width: 100%;font-size: smaller !important;">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            Tanggal Proses: {{ G_formatDateNonWIB(datalist.prosesdate)
                                                            }}<br>
                                                        </span>
                                                        <span v-else>
                                                            Processed Date: {{ G_formatDateNonWIB(datalist.prosesdate)
                                                            }}<br>
                                                        </span>
                                                        <span :style="'color:' + datalist.colordiproses">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li :style="'--cardColor:' + datalist.colorditindaklanjuti" style="background-color: #FAF0E6;padding: 30px;">
                                                <div class="content">
                                                    <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                                    <div class="title"><span
                                                            :style="'color:' + datalist.colorditindaklanjuti"
                                                            v-if="(bahasa === null) || (bahasa == 'ina')">Ditindaklanjuti</span>
                                                        <span v-else
                                                            :style="'color:' + datalist.colorditindaklanjuti">Follow-up</span>
                                                    </div>
                                                    <div class="text"
                                                        style="width: 100%;font-size: smaller !important;">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            Tanggal Ditindaklanjuti: {{
                                                                G_formatDateNonWIB(datalist.tindaklanjutdate) }}<br>
                                                        </span>
                                                        <span v-else>
                                                            Follow-up Date: {{
                                                                G_formatDateNonWIB(datalist.tindaklanjutdate) }}<br>
                                                        </span>
                                                        <span :style="'color:' + datalist.colorditindaklanjuti">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li :style="'--cardColor:' + datalist.colorselesai" style="background-color: #AFEEEE;padding: 30px;">
                                                <div class="content">
                                                    <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                                    <div class="title"><span :style="'color:' + datalist.colorselesai"
                                                            v-if="(bahasa === null) || (bahasa == 'ina')">Selesai</span>
                                                        <span v-else
                                                            :style="'color:' + datalist.colorselesai">Finished</span>
                                                    </div>
                                                    <div class="text"
                                                        style="width: 100%;font-size: smaller !important;">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            Tanggal Selesai: {{ G_formatDateNonWIB(datalist.finishdate)
                                                            }}<br>
                                                            Hasil: <span v-html="datalist.tindaklanjut"></span>
                                                        </span>
                                                        <span v-else>
                                                            Finished Date: {{ G_formatDateNonWIB(datalist.finishdate)
                                                            }}<br>
                                                            Result: <span v-html="datalist.tindaklanjut"></span>
                                                        </span>
                                                        <span :style="'color:' + datalist.colorselesai">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></br>
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ol>
                                    </template>
                                </div>
                            </div>
                        </center>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalresume()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <div id="modal-content">
        </div>
    </div>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">PENCARIAN ADUAN</span>
                <span v-else>FIND COMPLAINTS</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Pencarian Aduan</span>
                    <span v-else>Finc Complains</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <div class="section-title mb-2 wow fadeInDown" data-wow-delay="0.1s">
            <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                <div class="row">
                    <div class="col-sm-12 float-left pb-2 wow fadeInDown">
                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Register</label>
                        <label v-else>Register Code</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-sm" id="register" name="register"
                                placeholder="Kode Register / Register Code" v-model="register">
                        </div>
                    </div>
                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Keamanan</label>
                        <label v-else>Captcha</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                placeholder="Kode Keamanan" v-model="capcha" disabled>
                        </div>
                    </div>
                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Ulangi Kode Keamanan</label>
                        <label v-else>Repeat Captcha</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="far fa-clone"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-sm" id="capchainput" name="capchainput"
                                placeholder="" v-model="capchainput" style="text-transform:uppercase">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
        <div class="input-group">
            <div class="custom-control custom-switch custom-switch-on-primary">
                <input type="checkbox" class="custom-control-input" id="customSwitchAuth">
                <label class="custom-control-label" for="customSwitchAuth" @click="rubahisi()"
                    style="font-size: small;">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentikasi Pengguna Manusia</span>
                    <span v-else>Human User Authentication</span>
                </label>
            </div>
        </div>
        <div class="help-block text-center">&nbsp;</div>
        <button class="btn btn-danger2 btn-block text-white" placeholder="Kirim" data-toggle="tooltip"
            data-placement="left" title="Kirim aduan.." style="color: black;" v-on:click="aduanAct"
            :disabled="showHuman == false" v-if="(bahasa === null) || (bahasa == 'ina')">
            <b><i class="fas fa-search"></i>
                Cari
            </b>
        </button>
        <button class="btn btn-danger2 btn-block text-white" placeholder="Kirim" data-toggle="tooltip"
            data-placement="left" title="Kirim aduan.." style="color: black;" v-on:click="aduanAct"
            :disabled="showHuman == false" v-else>
            <b><i class="fas fa-search"></i>
                Search
            </b>
        </button>
    </div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            sourcenya: '',
            nama: '',
            register: '',
            capcha: this.makeid(5), capchainput: "",
            showHuman: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            master: [],
        };
    },
    methods: {
        tutupmodalresume() {
            $('#costumModalresume').modal('hide');
        },
        rubahisi() {
            if (this.showHuman == false) {
                this.showHuman = true;
            }
            else {
                this.showHuman = false;
            }
        },
        async aduanAct() {
            //alert(this.aduan);
            if ((this.register == "") || (this.register == "")) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon isikan salah satu kolom ..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                document.getElementById("nama").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
            }

            if (this.capchainput == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                document.getElementById("capchainput").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
            }
            if (this.capchainput.toUpperCase() != this.capcha) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Kode Keamanan Tidak Sama..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                document.getElementById("capchainput").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
            }

            const data = {
                project_id: this.project_id,
                register: this.register,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationMasyarakat-cari", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        //document.getElementById("nama").focus();
                        this.showHuman = false;
                        this.capcha = this.makeid(5);
                        this.capchainput = "";
                        document.getElementById('customSwitchAuth').checked = false;
                        return false;

                    }
                    else {
                        //alert('berhasil');
                        this.master = [];
                        this.master = Response.data.content.data;
                        var modal = document.getElementById("costumModalresume");
                        // Get the image and insert it inside the modal - use its "alt" text as a caption
                        //var img = document.getElementById(id);
                        modal.style.display = "block";

                        // Get the <span> element that closes the modal

                        this.showHuman = false;
                        this.capcha = this.makeid(5);
                        this.capchainput = "";
                        document.getElementById('customSwitchAuth').checked = false;
                        $('#costumModalresume').modal('show');
                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    document.getElementById("register").focus();
                    document.getElementById('customSwitchAuth').checked = false;
                    this.showHuman = false;
                    return false;
                }
            )

        },
    },
    mounted() {
        this.halamanloading = false;
    },
}
</script>

<style></style>